const openSparkChatModal = () => {
	if (typeof window !== "undefined") {
		window.dispatchEvent(new Event("OPEN_CHAT_MODAL"));
	}
};

export default openSparkChatModal;
